<app-navbar title="Lista klientów">
	<button class="btn btn-success" (click)="modalOpen()">Wybór restauracji</button>
</app-navbar>

<app-resident-select-restaurant [elements]="data" [restaurantList]="parameters.restaurantList" (closed)="modalClosed()">
</app-resident-select-restaurant>

<app-resident-customer-list-filter
	userFilters="residentCustomer"
	[destinations]="parameters.destinations"
	[products]="parameters.products"
	(selected)="filtersSelected($event)"
>
</app-resident-customer-list-filter>

<app-dynamic-table [elements]="data" [tableRows]="tableRows" [haveLink]="false" (filtersClicked)="filtersOpen()">
</app-dynamic-table>
